import produce from 'immer';

import {
  EDIT_PUSH_TEMPLATE_FAILURE,
  EDIT_PUSH_TEMPLATE_SEQUENCE_FAILURE,
  EDIT_PUSH_TEMPLATE_SEQUENCE_SUCCESS,
  EDIT_PUSH_TEMPLATE_SUCCESS,
  FETCH_PUSH_TEMPLATE_FAILURE,
  FETCH_PUSH_TEMPLATE_LIST_FAILURE,
  FETCH_PUSH_TEMPLATE_LIST_SUCCESS,
  FETCH_PUSH_TEMPLATE_SUCCESS,
} from '@actions/pushTemplate';

const initialState: IPushTemplateStore = {
  templates: null,
  currentTemplate: null,
  error: null,
};

export default (state: IPushTemplateStore = initialState, action: any) =>
  produce(state, (draftState: IPushTemplateStore) => {
    switch (action.type) {
      case FETCH_PUSH_TEMPLATE_LIST_SUCCESS:
      case EDIT_PUSH_TEMPLATE_SEQUENCE_SUCCESS:
        draftState.templates = action.response;
        draftState.error = null;

        return;

      case FETCH_PUSH_TEMPLATE_LIST_FAILURE:
      case EDIT_PUSH_TEMPLATE_SEQUENCE_FAILURE:
        draftState.error = action.error;

        return;

      case EDIT_PUSH_TEMPLATE_SUCCESS:
      case FETCH_PUSH_TEMPLATE_SUCCESS:
        draftState.currentTemplate = action.response;
        draftState.error = null;

        return;

      case EDIT_PUSH_TEMPLATE_FAILURE:
      case FETCH_PUSH_TEMPLATE_FAILURE:
        draftState.error = action.error;

        return;
    }
  });
